import { Elastic, Power1, TimelineMax, TweenMax } from "gsap";
import { CreateElement, Scale, SetStyles, Size } from "../../.././MyHelpers";
import { AudioManager, Track } from "../../../AudioManager";
import { IRandomInterval } from "../../../Context/RandomInterval";
import { ISystemContext } from "../../../Context/SystemContext";
import { MoneyFormatter } from "../../../MoneyFormatter";
import { FontResource } from "../../../ResourceManager/FontResource";
import { ImageResource } from "../../../ResourceManager/ImageResource";
import { Resourceful2 } from "../../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../ResourceManager/SpriteResource";
import { BigWinCountAnimation } from "../../../slot/BigWinCountAnimation";
import { BonusFinish, IBonusStartConfig } from "../../../slot/SlotGame";
import { CanvasSprite } from "../../../slot/Sprite/CanvasSprite";
import { Translator } from "../../../Translator";
import { SlotBonus2 } from "../SlotBonus2";
import { BigSymbolFreegames2Params } from "./BigSymbolFreegames2Params";
//import { BigSymbolFreegamesConfig } from "./BigSymbolFreegamesConfig";
import { Settings } from "../../../Settings";
import { ZIndex } from "../../../ZIndex";
import { MyCanvas, MyCanvasContext } from "../../MyCanvas";
import { BigSymbolFreegamesMessages } from "./BigSymbolFreegamesMessages";
import { BigSymbolFreegamesSession } from "./BigSymbolFreegamesSession";
import { BigSymbolFreegamesCommonConfiguration } from "../../../api";

export class BigSymbolFreegames2 extends SlotBonus2 implements Resourceful2 {

	protected view: HTMLElement = null;
	protected override resid: ResourceIdentifier;
	protected parentresid: ResourceIdentifier = null;

	//protected transition: SceneTransition = null;

	protected gameTitle: HTMLElement = null;

	protected gameBonusResourcesBasePath: string;
	protected commonBonusResourcesBasePath: string;
	protected viewSize: Size;

	protected session: BigSymbolFreegamesSession = new BigSymbolFreegamesSession("Screen-2");

	//protected elemWon: HTMLElement = null;
	//protected elemPlayed: HTMLElement = null;
	//protected elemLeft: HTMLElement = null;
	//CHANGE SIMPLE TEXT BY CANVAS
	protected winCountcanvasSpinLeft: MyCanvas [] = [];
	
	protected ctxSpinsRemaining : MyCanvasContext [] = [];
	protected fontHeight:number=Scale.fh(135);
	protected fontHeightWinCount:number=Scale.fh(200);
	protected fontFamily: string;
	

	protected win: HTMLElement = null;

	//protected wins: HTMLElement = null;
	protected bonustitle: HTMLElement = null;
	protected TotalPlayed: HTMLElement = null;
	protected played: HTMLElement = null;
	protected left: HTMLElement = null;


	protected winCreditAnimation: TweenMax = null;
	protected winValues: any = { win: 0 };

	protected glowRemainig: TimelineMax = null;
	protected glow: any = { glow: 0 };
	//container for spins wins
	protected spinsPlayedBackgroundSprite: CanvasSprite = null;
	//container for spins left
	protected spinsRemainingBackgroundSprite:CanvasSprite=null;

	protected basepath: string = null;

	protected TitleBonus: HTMLElement = null;
	protected runsPlayedCountAnimation: BigWinCountAnimation = null;

	protected moneyFormatter: MoneyFormatter = null;
	public translator: Translator;

	protected freegameStats2:HTMLElement;
	//Create  AUDIO 
	protected audio:AudioManager ;

	protected TitleFreeGameSprite: CanvasSprite = null;
	protected BonusWinSprite:CanvasSprite = null;
	
	protected BonusStartTimer: IRandomInterval = null;

	protected systemContext: ISystemContext = null;
	//WIN SHOW 
	protected FrameSprite: CanvasSprite = null;
	protected winContainer:HTMLElement = null;
	protected WinCountAnimation: BigWinCountAnimation = null;
	protected WinAllContainer: HTMLElement = null;
	protected BackgroundContainer: HTMLElement = null;
	protected WinCanvasShow: MyCanvas = null;
	protected ctxWinCanvasShow: MyCanvasContext = null;

	protected freegameStats:HTMLElement=null;
	
	//CREATE BOUNCE
	protected BounceAnim:TimelineMax =  new TimelineMax;
	
	//MARKO SCALE
	protected FreegamesNumTitle:HTMLElement=null;
	protected FreegamesNumValue:HTMLElement=null;
	protected FreegamesPlayedValue:HTMLElement=null;

	public BonusName(): string
	{
		return "BigSymbolFreegames";
	}

	public constructor(gameResid: ResourceIdentifier, params: BigSymbolFreegames2Params, config: BigSymbolFreegamesCommonConfiguration) {
		super(params.gameName, params);

		this.parentresid = gameResid;
		this.resid = gameResid.Add(this.bonusName + "2");
		this.translator = params.translator;
		this.systemContext = params.systemContext
		//INI AUDIO
		this.audio = params.audio;
		//this.params = params;
		this.gameBonusResourcesBasePath = params.gameBonusResourcesBasePath;
		this.commonBonusResourcesBasePath = params.commonBonusResourcesBasePath;
		this.viewSize = params.viewSize;

		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + params.gameName + "/";

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.style.position = "absolute";
		this.view.style.top = "0px";
		this.view.style.left = "0px";
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";

		//this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.PickMessage.msgname, (m) => this.OnPick((<FreegameMessages.PickMessage>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(BigSymbolFreegamesMessages.SpinMessage.msgname, (m) => this.OnSpin((<BigSymbolFreegamesMessages.SpinMessage>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(BigSymbolFreegamesMessages.PlusMessage.msgname, (m) => this.OnPlus((<BigSymbolFreegamesMessages.PlusMessage>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(BigSymbolFreegamesMessages.ShowWinContainer.msgname, (m) => this.ShowWin((<BigSymbolFreegamesMessages.ShowWinContainer>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(BigSymbolFreegamesMessages.ResetFinalContainerWin.msgname, (m) => this.ResetShowWin(), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(BigSymbolFreegamesMessages.TitleAnim.msgname, (m) => this.AnimTitle(), this.screenProtocolScope);
		
		//this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.WinMessage.msgname, (m) => this.Win((<FreegameMessages.WinMessage>m).session), this.screenProtocolScope);
		//this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.WinInterruptedMessage.msgname, (m) => this.WinInterrupt(), this.screenProtocolScope);
	

		this.moneyFormatter = params.moneyFormatter;

		this.systemContext = params.systemContext.CreateSubContext(this.bonusName);


	}

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//// Log.Debug(this.logGroup, this.)
		//resourceManager.Add(new HTMLResource(this.commonResourcesBasePath + "BigSymbolFreegames.2.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.commonResourcesBasePath + "BigSymbolFreegames.2.css", this.resid.ScopedResourceName("css"), this.parentresid.CSSScope()));

		//resourceManager.AddGlobal(new SpriteResource(this.gameResourcesBasePath + "transition", this.resid.Add("transition").Shared(), true, this.logGroup.Add("transition"), true));
		//Yo
		//resourceManager.Add(new ImageResource(this.gameBonusResourcesBasePath + "background.2.png", this.resid.ScopedResourceName(["background2", "image"])));
		//Yo
		await this.PrepareFonts(resourceManager);
		//LOAD AUDIO
		await this.AudioPrepare(resourceManager);

		await this.LoadSprites(resourceManager);

		
	}

	public AudioPrepare(resourceManager: IWriteOnlyResourceManager):void
	{
		//LOAD LIGHTING
		this.audio.AddTrack(new Track(this.commonBonusResourcesBasePath + "resources/tracks/BounceSound" + Settings.audioFormat, this.resid.ScopedResourceName("BounceSound")));
		this.audio.AddTrack(new Track(this.commonBonusResourcesBasePath + "resources/tracks/sfxnumber" + Settings.audioFormat, this.resid.ScopedResourceName("SFXnumber")));
	
	}

	protected PrepareFonts(resourceManager: IWriteOnlyResourceManager): void 
	{	
		//USE FOR LOAD FONT WIN SHOW
		resourceManager.Add(new FontResource(this.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
		//USE FOR STAT GAME FONT
		resourceManager.Add(new FontResource(this.gameBonusResourcesBasePath + "fontStyle.ttf", this.resid.ScopedResourceName("font")));
	}

	public LoadSprites(resourceManager: IWriteOnlyResourceManager) 
	{
	
		resourceManager.Add(new ImageResource(this.basepath + "resources/title.png", this.resid.ScopedResourceName(["title", "image"])));
		resourceManager.AddGlobal(new SpriteResource(this.gameBonusResourcesBasePath + "ValueContainer", ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName+"ValueContainer"), true, this.logGroup.Add(this.gameName), true));
		resourceManager.AddGlobal(new SpriteResource(this.commonBonusResourcesBasePath + "resources/TextContainer", ResourceIdentifier.Global.Add("BigSymbolFreegames").Add("TextContainer"), true, this.logGroup.Add("TextContainer"), true));
		//resourceManager.AddGlobal(new SpriteResource(this.gameBonusResourcesBasePath + "sfxnumber", this.resid.Add("BigSymbolFreegames").Add("sfxnumber"), true, this.logGroup.Add("sfxnumber"), true));
		resourceManager.AddGlobal(new SpriteResource(this.commonBonusResourcesBasePath + "resources/BonusWin", ResourceIdentifier.Global.Add("BigSymbolFreegames").Add("BonusTitleBigSymbolFreegames"), true, this.logGroup.Add("freegame"), true));
		resourceManager.Add(new SpriteResource(this.commonBonusResourcesBasePath + "resources/frameSprite", this.resid.Add("frameSprite"), true, this.logGroup.Add("frameSprite"), true));
		resourceManager.AddGlobal(new SpriteResource(this.commonBonusResourcesBasePath + "resources/FreeGameTitleBounce", ResourceIdentifier.Global.Add("BigSymbolFreegames").Add("FreeGameTitleBounce"), true, this.logGroup.Add("freegame"), true));
	
	}

	public async LoadedSprites(resourceManager: IReadOnlyResourceManager)
	{
		//MOVE POSITION FOR OVERWRITE FOR 2Screen Game
		await this.FreeGameTitleSprite(resourceManager)
		
	    //this.FreeGameStatsRight();		
		await this.SpinsPlayedSprite(resourceManager);

		// this.view.appendChild(this.freegameStats2);
	
		// this.freegameStats2.appendChild(this.TotalPlayed);

		await this.SpinsRemainingSprite(resourceManager);


	}

	protected FreeGameTitleSprite(resourceManager: IReadOnlyResourceManager)
	{

		this.TitleBonus = CreateElement("div", {
			classes: [this.resid.Scope() + "-game-title"],
			parentToAppend:this.view,
			style: {
				position: "absolute",
				width: Scale.Wpx(1920),
				height: Scale.Hpx(203),
				top: Scale.Ypx(0),
				display: "flex",
				justifyContent: "center",
				alignContent: "center",
				zIndex:ZIndex.HoldAndStopTitle.toString(),
				backgroundPosition:"center",
				backgroundSize:"contain",
				backgroundRepeat:"no-repeat",
			}
		});
		//this.TitleBonus = this.view.querySelector(".game-title");
		// this.TitleBonus.style.display="flex";
		// this.TitleBonus.style.alignContent="center";
		// this.TitleBonus.style.justifyContent="center";
		// this.TitleBonus.style.width=Scale.Wpx(1920);	
		// this.TitleBonus.style.height=Scale.Hpx(203);	
		// //this.TitleBonus.style.position="absolute";
		//this.TitleBonus.style.top=Scale.Xpx(0);
		//this.TitleBonus.style.zIndex=ZIndex.HoldAndStopTitle.toString();

		this.TitleFreeGameSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add("FreeGameTitleBounce")).sprite, canvasSize: new Size(Scale.W(1920),Scale.H(203))});
		//this.TitleFreeGameSprite.ScaleNonUniform(1.5,1);
		//this.TitleFreeGameSprite.Start(true);
		this.TitleFreeGameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("BounceSound")));
		
		
		//this.BonusStartTimer = this.systemContext.TimingContext().CreateRandomInterval("diamondStartTimer", 5000,10000, () => this.TitleFreeGameSprite.Start(false));
		this.TitleBonus.appendChild(this.TitleFreeGameSprite.View());
		this.view.appendChild(this.TitleBonus);
		
	}

	 protected SpinsRemainingSprite(resourceManager: IReadOnlyResourceManager)
	{
		this.spinsRemainingBackgroundSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName+"ValueContainer")).sprite, canvasSize: new Size(Scale.W(536), Scale.H(430))});
		this.spinsRemainingBackgroundSprite.Start(true);
		this.spinsRemainingBackgroundSprite.View().style.position="absolute";
		this.spinsRemainingBackgroundSprite.View().style.left=Scale.Xpx(-51);
		this.spinsRemainingBackgroundSprite.View().style.top=Scale.Ypx(0);
		this.freegameStats.appendChild(this.spinsRemainingBackgroundSprite.View());

	}

	protected SpinsPlayedSprite(resourceManager: IReadOnlyResourceManager)
	{
		this.spinsPlayedBackgroundSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName+"ValueContainer")).sprite, canvasSize: new Size(Scale.W(536), Scale.H(430))});
		this.spinsPlayedBackgroundSprite.Start(true);
		this.spinsPlayedBackgroundSprite.View().style.position="absolute";
		this.spinsPlayedBackgroundSprite.Start(true);
		this.spinsPlayedBackgroundSprite.View().style.left=Scale.Xpx(-51);
		this.spinsPlayedBackgroundSprite.View().style.top=Scale.Ypx(0);
		this.freegameStats2.appendChild(this.spinsPlayedBackgroundSprite.View());
		
	}

	protected FreeGameStatsRight(){
		this.freegameStats2 = CreateElement("div", {
			classes: [this.resid.Scope() + "-freegameStats2"],
			style: {
				position: "absolute",
				right: Scale.Xpx(0),
				width: Scale.Wpx(422),
				height: Scale.Hpx(615),
				top: Scale.Ypx(415),
				display: "flex",
				justifyContent: "center",
				alignContent: "center",
				flexDirection:"column",
				boxSizing:"border-box",
				zIndex: ZIndex.freegameStats2.toString(),
			}
		});

		this.FreegamesPlayedValue = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegames-right-value","freegames-played-num-value"],
			parentToAppend:this.freegameStats2,
			style: {
				position: "relative",
				left:Scale.Xpx(0),
				top:Scale.Xpx(-25),
				//width:Scale.Xpx(460),
				
			}
		});

		this.TotalPlayed = CreateElement("div", {
			classes: [this.resid.Scope() + "-total-played"],
			parentToAppend: this.freegameStats2,
			style: {
				position: "relative",
				top:Scale.Xpx(124),
				lineHeight:Scale.fhpx(77),
				fontSize:Scale.fh(4.5)+"em",
				fontFamily:this.resid.ScopedResourceName("font"),				
				color:"yellow",
				textAlign:"center",
				alignItems:"center",
				alignContent:"center",
				alignSelf:"center",
				margin:Scale.XYpx(25),
				//zIndex:ZIndex.freegameStats2.toString(),
				textShadow: `0px ${Scale.Xpx(10)} ${Scale.Ypx(10)} black, 0px 0px ${Scale.Ypx(10)} black, 0px 0px ${Scale.XYpx(20)} black`

			}
		});
		this.view.appendChild(this.freegameStats2);
	
		this.freegameStats2.appendChild(this.TotalPlayed);

		// this.TotalPlayed = this.view.querySelector(".total-win");
		// this.TotalPlayed.style.left="-5px";
		// this.TotalPlayed.style.top="400px";
		// this.TotalPlayed.style.height="100px";
		// this.TotalPlayed.style.width="400px";
		// this.TotalPlayed.style.fontSize="4.5em";		
		// this.TotalPlayed.style.zIndex=ZIndex.HoldAndStopBonusStats.toString();
		

	}

	protected CanvaswinCountShow(resourceManager: IReadOnlyResourceManager)
	{
		this.WinCanvasShow = new MyCanvas(new Size(Scale.W(1580), Scale.H(350)), {
            style: {
                top:Scale.Ypx(150),
                left:Scale.Xpx(61),
                position: "absolute",
                alignItems: "center",
                justifyContent: "center",
                zIndex: ""+ ZIndex.BonusWin,
            }
        });
		this.winContainer.appendChild(this.WinCanvasShow.View());		
	}


	public async ResourcesLoaded(oadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {



		//this.transition = new SceneTransition(this.logGroup, this.viewSize, new CanvasSprite(resourceManager.Get<SpriteResource>(this.resid.Add("transition").Shared()).sprite, this.viewSize));

		//this.view.innerHTML = resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;
	
		//this.elemWon = this.view.querySelector(".freegames-won-value");
		//this.elemPlayed = this.view.querySelector(".freegames-played-value");
		
		
		//DONT USE THIS 
		// this.win = document.createElement("div");
		// //this.win.style.marginLeft="383px";
		// //this.win.style.marginRight="383px";
		// this.win.style.width="100%";
		// this.win.style.top="355px";
		// this.win.style.zIndex=ZIndex.HoldAndStopBonusStats.toString();
		//Yo
		// this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background2", "image"])).CssBackground();
		// this.view.style.backgroundSize = "contain";
		// this.view.style.backgroundRepeat = "no-repeat";
		//Yo
		//this.freegameStats2.appendChild(this.win);



	


		// let textvalueleft:HTMLElement  = this.view.querySelector(".freegames-num-title");
		// textvalueleft.style.position="relative";
		// //textvalueleft.style.left="26px";
		// textvalueleft.style.top="171px";
		// textvalueleft.style.lineHeight="77px";
		// textvalueleft.style.fontSize="4.5em";
		
	


		//this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background2", "image"])).CssBackground();

		//this.bonustitle = this.view.querySelector(".bonustitle");
		//this.wins = this.view.querySelector("#won");
		
		// this.TotalPlayed = this.view.querySelector(".total-win");
		// this.TotalPlayed.style.left="-5px";
		// this.TotalPlayed.style.top="400px";
		// this.TotalPlayed.style.height="100px";
		// this.TotalPlayed.style.width="400px";
		// this.TotalPlayed.style.fontSize="4.5em";		
		// this.TotalPlayed.style.zIndex=ZIndex.HoldAndStopBonusStats.toString();
		// this.played = this.view.querySelector("#played");
		//this.left = this.view.querySelector("#left");
		// this.freegameStats2.appendChild(this.TotalPlayed);
		
		await this.FreeGameStatsLeft();
		await this.FreeGameStatsRight();		
	
		await this.LoadedSprites(resourceManager);

		// this.freegameStats.appendChild(this.spinsRemainingBackgroundSprite.View());
		//let transitionView: HTMLElement = this.transition.View();
		//this.view.appendChild(transitionView);

		// let freegameleftcontainer: HTMLElement = this.view.querySelector(".freegames-left");
		// SetStyles(freegameleftcontainer,
		// 	{
		// 		flexDirection:"column",
		// 	});
		//Create for overwrite the size number anim right for 2 Screen
		await this.PlayedCountAnimation();

		//this.bonustitle.appendChild(this.translator.Anchor(() => this.translator.t.freegameStats2));
		this.TotalPlayed.appendChild(this.translator.Anchor(() => this.translator.t.playedBigFG));
		//this.wins.appendChild(this.translator.Anchor(() => this.translator.t.win));
		//this.played.appendChild(this.translator.Anchor(() => this.translator.t.played));
		this.FreegamesNumTitle.appendChild(this.translator.Anchor(() => this.translator.t.totalleftHoldAndSpin));

		
		await this.CanvaswinCount(resourceManager);
		await this.WinFrameLoaded(resourceManager);
		
		await this.CanvaswinCountShow(resourceManager);
	
	}


	protected FreeGameStatsLeft()
	{
		this.freegameStats = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegame-stats"],
			parentToAppend:this.view,
			style: {
				display:"flex",
				position:"absolute",
				width:Scale.Wpx(422),
				height:Scale.Hpx(615),
				top:Scale.Ypx(415),
				zIndex:ZIndex.HoldAndStopBonusStats.toString(),
				bottom:Scale.Ypx(0),
				justifyContent:"center",
				flexDirection:"column",
				boxSizing:"border-box",
				
			}
		});

		this.FreegamesNumValue = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegames-left-value","freegames-num-value"],
			parentToAppend:this.freegameStats,
			style: {
				position: "relative",
				left:Scale.Xpx(0),
				top:Scale.Xpx(10),
				// width:Scale.Xpx(460),
				
			}
		});


		this.FreegamesNumTitle = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegames-num-title"],
			parentToAppend:this.freegameStats,
			style: {
				position: "relative",
				top:Scale.Xpx(74),
				lineHeight:Scale.fhpx(77),
				fontSize:Scale.fh(4.5)+"em",
				fontFamily:this.resid.ScopedResourceName("font"),				
				color:"yellow",
				textAlign:"center",
				alignItems:"center",
				alignContent:"center",
				alignSelf:"center",
				margin:Scale.XYpx(25),
				textShadow: `0px ${Scale.Xpx(10)} ${Scale.Ypx(10)} black, 0px 0px ${Scale.Ypx(10)} black, 0px 0px ${Scale.XYpx(20)} black`
			}
		});
	}

	protected PlayedCountAnimation()
	{
		// this.runsPlayedCountAnimation = new BigWinCountAnimation(this.resid, new Size(Scale.W(460),Scale.H(415)),this.fontHeight,  this.resid.ScopedResourceName("bigwincount"));

		// let countView = this.runsPlayedCountAnimation.View();
		// countView.style.position = "absolute";
		// countView.style.top =Scale.Ypx(12);
		// countView.style.right = Scale.XYpx(-22);
		// //countView.style.width = "1920px";
		// countView.style.pointerEvents = "none";
		// countView.style.zIndex="";
		
		// this.freegameStats2.appendChild(countView);
	}

	protected WinFrameLoaded(resourceManager: IReadOnlyResourceManager)
	{

		this.WinAllContainer = document.createElement("div");
		this.WinAllContainer.style.width=Scale.Wpx(1920);
		this.WinAllContainer.style.height=Scale.Hpx(1080);
		this.WinAllContainer.style.position="absolute";
		this.WinAllContainer.style.justifyContent="center";
		this.WinAllContainer.style.alignContent="center";
		this.WinAllContainer.style.overflow="hidden";
		this.WinAllContainer.style.zIndex=ZIndex.WinContainerBigFG.toString();
		// this.WinAllContainer.style.backgroundColor="rgba(0,0,0,0.5)";
		this.WinAllContainer.style.display="block";

		
		this.BonusWinLoaded(resourceManager);
		
		this.winContainer = document.createElement("div");
		this.winContainer.classList.add(this.resid.Scope());
		this.winContainer.classList.add("WinContainer");
		SetStyles(this.winContainer,
		{
			position : "absolute",
			top:Scale.Ypx(257),
			//left: "0px",
			width:Scale.Wpx(1728),
			height:Scale.Hpx(423),
			display:"none",
			//flexDirection:"column",
			
			
		});

		this.BackgroundContainer = CreateElement("div", {
			parentToAppend: this.winContainer,
			style: {
				backgroundColor: "rgba(0,0,0,0.7)",
				width: Scale.Wpx(1590),
				height: Scale.Hpx(347),
				position: "absolute",
				top: Scale.Ypx(133),
				left: Scale.Xpx(63),

			}
		});

		this.CreateSpriteContainer(resourceManager);
		this.WinAllContainer.appendChild(this.winContainer);
		this.view.appendChild(this.WinAllContainer);
	}

	protected CreateSpriteContainer(resourceManager: IReadOnlyResourceManager)
	{
		//CHANGE TO SPRITE 
		let sprite = resourceManager.Get<SpriteResource>(this.resid.Add("frameSprite")).sprite;
		this.FrameSprite = new CanvasSprite({sprite: sprite, canvasSize: new Size(Scale.W(1720),Scale.H(500))});
		//this.FrameSprite.ScaleNonUniform(1,1.3);
		//this.FrameSprite.View().style.zIndex="4";
		this.FrameSprite.View().style.position="absolute";
		this.FrameSprite.View().style.top= Scale.Ypx(65);
		//this.FrameSprite.View().style.display="none";
		this.FrameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
		
	
		// this.WinCountAnimation = new BigWinCountAnimation(this.resid, new Size(Scale.H(1920), Scale.W(400)), Scale.fh(600),  this.resid.ScopedResourceName("bigwincount"));

		// let countView = this.WinCountAnimation.View();
		// countView.style.position = "relative";
		// countView.style.top =Scale.Ypx(-47);
		// //countView.style.left = "32px";
		// //countView.style.width = "1920px";
		// //countView.style.pointerEvents = "none";

		//this.FrameSprite.View().appendChild(countView);
		this.winContainer.appendChild(this.FrameSprite.View());
	}
	

	protected BonusWinLoaded(resourceManager: IReadOnlyResourceManager)
	{
		this.BonusWinSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add("BonusTitleBigSymbolFreegames")).sprite, canvasSize: new Size(Scale.W(1920),Scale.H(339))});
			//this.TitleFreeGameSprite.Start(true);
		this.BonusWinSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("BounceSound")));
		this.BonusWinSprite.View().style.display="none";
		this.BonusWinSprite
		
		this.WinAllContainer.appendChild(this.BonusWinSprite.View());
		this.BounceAnim = new TimelineMax({
			paused: true,
			repeat: -1,
		});

		this.BounceAnim

			/* ball bounce up */
			.fromTo(this.BonusWinSprite.View(), 0.5, {

				y: Scale.Y(45),

			}, {
				y:Scale.Y(-100),
				ease: Power1.easeOut, transformOrigin: "50% 50%",
			}
				, "bounce")

			/* ball bounce down */
			.to(this.BonusWinSprite.View(), 0.4, {
				transformOrigin: "50% 50%",
				y:Scale.Y(40),
				ease: Power1.easeIn
				//ease: Power1.easeInOut
			}, "bounce2")

			/* ball squash */
			.to(this.BonusWinSprite.View(), 0.35, {
				transformOrigin: "50% 100%",
				//scaleX: Scale.X(1),
				scaleY: 0.30,
				ease: Power1.easeInOut
				//ease: Bounce.easeOut
			}, "bounce3")

			.to(this.BonusWinSprite.View(), 0.35, {
				transformOrigin: "100% 100%",
				//scaleX: Scale.X(1),
				scaleY: 1,
				ease: Power1.easeInOut,
				}, "bouncefinal");

	}



	protected CanvaswinCount(resourceManager: IReadOnlyResourceManager)
	{
		for(let a=0;a<2;a++){

		
		this.winCountcanvasSpinLeft[a]= new MyCanvas(new Size(Scale.W(422), Scale.H(200)), {
            style: {
                position: "relative",
		        zIndex: ""+ ZIndex.BonusWin,
            }
        });

		//add gradient
		this.ctxSpinsRemaining[a] = this.winCountcanvasSpinLeft[a].context;
		
        //this.ctx.font = "120px Verdana" /*+ this.font*/;
		this.ctxSpinsRemaining[a].font = "bold " + this.fontHeight + "px " + this.resid.ScopedResourceName("bigwincount") ;

		let color:string="orangered";
		let color2:string="yellow";

		let gradient = this.ctxSpinsRemaining[a].createLinearGradient(
            this.winCountcanvasSpinLeft[a].size.Width /2, 
			this.winCountcanvasSpinLeft[a].size.Height /2 - this.fontHeight/2, 
			this.winCountcanvasSpinLeft[a].size.Width /2, 
			this.winCountcanvasSpinLeft[a].size.Height /2 + this.fontHeight/2
		);

		this.ctxSpinsRemaining[a].lineJoin="round"; //Experiment with "bevel" & "round" for the effect you want!
		this.ctxSpinsRemaining[a].miterLimit=2;

		gradient.addColorStop(0,color);
			
		gradient.addColorStop(0.70,color2);
		
		
		gradient.addColorStop(1,color);
		
	
		this.ctxSpinsRemaining[a].fillStyle = gradient;
	
		this.ctxSpinsRemaining[a].textBaseline = "top";
		this.ctxSpinsRemaining[a].textAlign="center";
		
		

		if(a == 0)
		{
		this.FreegamesNumValue.appendChild(this.winCountcanvasSpinLeft[a].View());
		}
		
		if(a == 1)
		{
		this.FreegamesPlayedValue.appendChild(this.winCountcanvasSpinLeft[a].View());
		}
	}
		
	
	

		// let value:HTMLElement = this.view.querySelector(".freegames-left-value");
		// value.style.position="relative";
		// value.style.left="-66px";
		// value.style.top="42px";	
		// value.style.width="100%";	
		// value.appendChild(this.winCountcanvasSpinLeft[a]);		
			



	}
	/******
		
	******/

	// TODO
	protected recover:boolean = false;

	public Prepare(bonusStartConfig: IBonusStartConfig)
	{

	}

	public Start(): void {
		if (this.session == null) {
			throw new Error("Session must not be null");

		}

		// clear values before start
		//this.elemWon.innerHTML = "?";
		//this.elemPlayed.innerHTML = "?";
		//this.elemLeft.innerHTML = "?";
		
		this.SetTextCanvas(this.session.RunsRemaining.toString(),this.winCountcanvasSpinLeft[0] , this.fontHeight);
        this.SetTextCanvas("0",this.winCountcanvasSpinLeft[1] , this.fontHeight);
	
		//this.runsPlayedCountAnimation.Display(0);

		//this.win.innerHTML = "?";
		//this.runsPlayedCountAnimation.View().style.visibility = "visible";
		//this.bigWinCountAnimation.Display(0);
		//this.BonusStartTimer.Start();
		//this.transition.Start();
		this.session.Reset();
		

	}
	
	public SetTextCanvas(text: string, CanvasElement: MyCanvas, fontHeight: number) {
		CanvasElement.context.clearRect(0, 0, CanvasElement.size.Width, CanvasElement.size.Height);

		//this.ctx.font = "120px Verdana" /*+ this.font*/;
		CanvasElement.context.font = "bold " + fontHeight + "px " + this.resid.ScopedResourceName("bigwincount");

		let color: string = "orangered";
		let color2: string = "yellow";

		let gradient = CanvasElement.context.createLinearGradient(
			CanvasElement.size.Width / 2,
			CanvasElement.size.Height / 2 - fontHeight / 2,
			CanvasElement.size.Width / 2,
			CanvasElement.size.Height / 2 + fontHeight / 2
		);

		CanvasElement.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		CanvasElement.context.miterLimit = 2;

		gradient.addColorStop(0, color);

		gradient.addColorStop(0.70, color2);


		gradient.addColorStop(1, color);


		CanvasElement.context.fillStyle = gradient;

		CanvasElement.context.textBaseline = "top";
		CanvasElement.context.textAlign = "center";

		CanvasElement.context.strokeStyle = "black";
		CanvasElement.context.lineWidth = Scale.fh(22);
		CanvasElement.context.strokeText(text, (CanvasElement.size.Width / 2) + 5, (CanvasElement.size.Height / 4) - 15);

		CanvasElement.context.strokeStyle = "white";
		CanvasElement.context.lineWidth = Scale.fh(22) / 4;
		CanvasElement.context.strokeText(text, (CanvasElement.size.Width / 2) + 5, (CanvasElement.size.Height / 4) - 15);

		CanvasElement.context.fillText(text, (CanvasElement.size.Width / 2) + 5, (CanvasElement.size.Height / 4) - 15);
		CanvasElement.RestoreContext();

	}



	public Update(): void {
		//this.transition.Update();
		this.spinsPlayedBackgroundSprite.Update();
		this.spinsRemainingBackgroundSprite.Update();
		this.TitleFreeGameSprite.Update();
		this.FrameSprite.Update();
		this.BonusWinSprite.Update();
		if (this.winCountcanvasSpinLeft[0].WasContextLost()) {
			this.SetTextCanvas(this.session.RunsRemaining.toString(), this.winCountcanvasSpinLeft[0], this.fontHeight);
		}
		if (this.winCountcanvasSpinLeft[1].WasContextLost()) {
			this.SetTextCanvas(this.session.RunsPlayed.toString(), this.winCountcanvasSpinLeft[1], this.fontHeight);
		}
		if (this.WinCanvasShow.WasContextLost()) {
			this.SetTextCanvas(this.moneyFormatter.FormatCurrency(this.session.TotalWin), this.WinCanvasShow, this.fontHeightWinCount);
		}
		//this.runsPlayedCountAnimation.Display(this.session.RunsPlayed);
		

	}

	public View(): HTMLElement {
		return this.view;
	}

	public OnBonusFinish(bonusFinish: BonusFinish): void {

	}
	public Hide(): void {
		this.view.style.visibility = "hidden";
	}
	public Show(): void {
		this.view.style.visibility = "visible";
	}
	public Reset(): void {
	}

	/*********
		SCREEN PROTOCOL EVENTS
	**********/

	// protected OnPick(session: FreegameSession): void {
	// 	if (session == null) {
	// 		throw new Error("Session must not be null");

	// 	}
	// 	this.WinValueSprite.Start(false);
	// 	//this.transition.Start();
	// 	this.session.Update(session);
	// 	this.ApplySession();
	// }


	protected OnSpin(session: BigSymbolFreegamesSession): void {
		if (session == null) {
			throw new Error("Session must not be null");
		}
		this.recover = false;
		this.session.Update(session);
		this.ApplySession();
		
		
	}
	protected OnPlus(session: BigSymbolFreegamesSession): void {

		this.TitleFreeGameSprite.Start(false);
	
		if (session == null) {
			throw new Error("Session must not be null");

		}

		if (session.RunsRemaining > this.session.RunsRemaining) {
			//this.spinsPlayedBackgroundSprite.Start(false);		

		}

		this.session.Update(session);
		setTimeout(() =>this.ApplySession(),300);
	}


	

	protected ShowWin(session: BigSymbolFreegamesSession)
	{
		this.FrameSprite.Start();
		this.session.Update(session);
		this.SetTextCanvas(this.moneyFormatter.FormatCurrency(this.session.TotalWin), this.WinCanvasShow,this.fontHeightWinCount);

		TweenMax.fromTo(this.winContainer, 2.5, {
			x: this.viewSize.Width, display:"block",
		}, {
			x: Scale.X(110),  ease: Elastic.easeOut.config(0.50, 0.4)
		});

		TweenMax.fromTo(this.BonusWinSprite.View(), 1, {
			autoAlpha:0, display:"block"
		},{
			autoAlpha:1
		});

		
		this.BounceAnim.play();


		//HIDE FREEGAME STATS
		TweenMax.fromTo(this.freegameStats, 1, {
			autoAlpha:1
		},{
			autoAlpha:0
		});

		TweenMax.fromTo(this.freegameStats2, 1, {
			autoAlpha:1
		},{
			autoAlpha:0
		});

		TweenMax.fromTo(this.TitleFreeGameSprite.View(), 1, {
			autoAlpha:1
		},{
			autoAlpha:0
		});
	}

	protected ResetShowWin()
	{
		this.FrameSprite.Stop();
		this.audio.Stop(this.resid.ScopedResourceName("BounceSound"));
		TweenMax.to(this.freegameStats, 0.5, {
			autoAlpha:1
		});

		TweenMax.to(this.freegameStats2, 0.5, {
			autoAlpha:1
		});

		TweenMax.to(this.TitleFreeGameSprite.View(), 0.5, {
			autoAlpha:1
		});

		
		TweenMax.to(this.winContainer, 2.5, {
			x: this.viewSize.Width, display:"none",
		}, );

		this.BounceAnim.restart();
		this.BounceAnim.pause();
		this.BonusWinSprite.View().style.display="none";
		

	}
	
	protected AnimTitle()
	{
		this.TitleFreeGameSprite.Start(false);
	}


	// protected Win(session: FreegameSession): void {
	// 	if (session == null) {
	// 		throw new Error("Session must not be null");

	// 	}

	// 	this.session.Update(session);
	// 	this.ApplySession();
	// 	this.bigWinCountAnimation.View().style.visibility = "visible";

	// 	this.winCreditAnimation = TweenMax.fromTo(
	// 		this.winValues,
	// 		this.session.winDuration,
	// 		{ win: this.session.TotalPlayed - session.win },
	// 		{
	// 			win: this.session.TotalPlayed, roundProps: "win",
	// 			onUpdate: () => {
	// 				//this.bigWinCountAnimation.Display(this.moneyFormatter.CentsToCredit(this.winValues.win));
	// 				//this.win.innerHTML = ""+(this.winValues.win);
	// 				//this.panel.SetWin(""+this.winValues.win, ""+this.winValues.win);
	// 			}
	// 		}
	// 	);
	// }

	protected WinInterrupt(): void {
		if (this.winCreditAnimation) {
			this.winCreditAnimation.kill();
		}

		//this.bigWinCountAnimation.Display(this.moneyFormatter.CentsToCredit(this.session.awarded));
	}

	protected ApplySession() {
		//this.elemWon.innerHTML = "" + this.session.awarded;
		//this.elemPlayed.innerHTML = "" + this.session.played;
		//this.elemLeft.innerHTML = "" + this.session.left;
		
		this.SetTextCanvas(this.session.RunsRemaining.toString(), this.winCountcanvasSpinLeft[0], this.fontHeight);
		//this.runsPlayedCountAnimation.Display(this.session.RunsPlayed);
		this.SetTextCanvas(this.session.RunsPlayed.toString(),this.winCountcanvasSpinLeft[1], this.fontHeight);

		if(this.recover)
		{
		//	this.runsPlayedCountAnimation.View().style.visibility = "visible";
		}

			//this.bigWinCountAnimation.Display(this.session.played);

		//this.win.innerHTML = ""+this.session.TotalPlayed;
	}

	public Stop() {
		//this.runsPlayedCountAnimation.View().style.visibility = "hidden";
	}
}

export interface IBigSymbolFreegames2Factory {
	CreateBigSymbolFreegames2(gameName: ResourceIdentifier, params: BigSymbolFreegames2Params, config: BigSymbolFreegamesCommonConfiguration): BigSymbolFreegames2;
}

export class BigSymbolFreegames2Factory implements IBigSymbolFreegames2Factory {

	public CreateBigSymbolFreegames2(gameName: ResourceIdentifier, params: BigSymbolFreegames2Params, config: BigSymbolFreegamesCommonConfiguration): BigSymbolFreegames2 {
		return new BigSymbolFreegames2(gameName, params, config);
	}
}
